export function getQueryParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const params = {};
    // Iterate through the parameters and add them to your object
    for (const [key, value] of urlParams.entries()) {
        params[key.toLowerCase()] = value;
    }
    return params;
}
/** localStorage-Schlüssel der Sitzung (der Lizenzschlüssel bleibt erhalten, er füllt das Login-Formular vor). */
export const SESSION_STORAGE_KEYS = ['accessToken', 'profileId', 'externalSystem', 'profileName'];
/**
 * `window.localStorage`, oder null, wenn schon der Zugriff auf die Eigenschaft wirft (Website-Daten blockiert →
 * SecurityError). Als Default-Parameter ausgewertet, darum mit eigenem try: ein Default-Ausdruck liegt außerhalb
 * des try-Blocks der Funktion.
 */
function browserStorage() {
    try {
        return window.localStorage;
    }
    catch (_a) {
        return null;
    }
}
/**
 * Access-Token aus dem localStorage lesen. Die App speichert ihn JSON-kodiert (`"…"`); ältere Sitzungen können ihn
 * roh enthalten, defekte Werte (`""`, `undefined`, `null`) kommen ebenfalls vor. Liefert den Token oder null und
 * wirft nie – ein kaputter Wert darf den Start des Formulars nicht verhindern.
 */
export function readAccessToken(storage = browserStorage()) {
    let raw = null;
    try {
        raw = storage ? storage.getItem('accessToken') : null;
    }
    catch (_a) {
        return null;
    }
    if (raw === null) {
        return null;
    }
    const trimmed = raw.trim();
    if (!trimmed || trimmed === 'undefined' || trimmed === 'null') {
        return null;
    }
    try {
        const parsed = JSON.parse(trimmed);
        return typeof parsed === 'string' && parsed.trim() ? parsed.trim() : null;
    }
    catch (_b) {
        return trimmed; // roh gespeicherter Token einer älteren Version
    }
}
/** Sitzungsreste entfernen (kein Logout-Ersatz: nur Aufräumen vor einem Neustart oder ohne gültigen Token). Wirft nie. */
export function clearSession(storage = browserStorage()) {
    if (!storage) {
        return;
    }
    for (const key of SESSION_STORAGE_KEYS) {
        try {
            storage.removeItem(key);
        }
        catch (_a) {
            // Speicher nicht verfügbar (z. B. blockierte Website-Daten) – nichts zu entfernen
        }
    }
}
